import {
  DialogNavigation,
  DialogPage,
} from "../../../../../../../components/modal/Dialog";
import { SellarCreditCheckSearchCompany } from "./components/SellarCreditCheckSearchCompany";
import { SellarCreditCheckWelcome } from "./components/SellarCreditCheckWelcome";
import { SellarCreditTwoDialogPageEnum } from "./types/SellarCreditTwoDialogPageEnum";
import { SellarCreditCheckNotEligible } from "./components/SellarCreditCheckNotEligible";
import { SellarCreditCheckCreditLimit } from "./components/SellarCreditCheckCreditLimit";
import { SellarCreditCheckLoginCheck } from "./components/SellarCreditCheckLoginCheck";
import { SellarCreditCheckLoginPrompt } from "./components/SellarCreditCheckLoginPrompt";
import { SellarCreditCheckInviteDirector } from "./components/SellarCreditCheckInviteDirector";
import { TwoAccountVerificationGetStarted } from "./components/TwoAccountVerificationGetStarted";
import { TwoBusinessRegistrationApplication } from "./components/TwoBusinessRegistrationApplication";
import { TwoAccountVerificationIntro } from "./components/TwoAccountVerificationIntro";

export const TwoSellarCreditCheckDialogContent = ({
  onDismiss,
}: {
  onDismiss: () => void;
}) => {
  return (
    <>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        className="gap-0"
      />
      <DialogPage page={SellarCreditTwoDialogPageEnum.WELCOME}>
        <SellarCreditCheckWelcome />
      </DialogPage>

      <DialogPage page={SellarCreditTwoDialogPageEnum.SEARCH_COMPANY}>
        <SellarCreditCheckSearchCompany />
      </DialogPage>

      <DialogPage
        page={
          SellarCreditTwoDialogPageEnum.TWO_BUSINESS_REGISTRATION_APPLICATION
        }
      >
        <TwoBusinessRegistrationApplication />
      </DialogPage>

      <DialogPage page={SellarCreditTwoDialogPageEnum.NOT_ELIGIBLE}>
        <SellarCreditCheckNotEligible />
      </DialogPage>

      <DialogPage page={SellarCreditTwoDialogPageEnum.CREDIT_LIMIT}>
        <SellarCreditCheckCreditLimit />
      </DialogPage>

      <DialogPage
        page={SellarCreditTwoDialogPageEnum.TWO_ACCOUNT_VERIFICATION_INTRO}
      >
        <TwoAccountVerificationIntro />
      </DialogPage>

      <DialogPage
        page={
          SellarCreditTwoDialogPageEnum.TWO_ACCOUNT_VERIFICATION_GET_STARTED
        }
      >
        <TwoAccountVerificationGetStarted />
      </DialogPage>

      <DialogPage page={SellarCreditTwoDialogPageEnum.LOGIN_CHECK}>
        <SellarCreditCheckLoginCheck />
      </DialogPage>

      <DialogPage page={SellarCreditTwoDialogPageEnum.LOGIN_PROMPT}>
        <SellarCreditCheckLoginPrompt />
      </DialogPage>

      <DialogPage page={SellarCreditTwoDialogPageEnum.INVITE_DIRECTOR}>
        <SellarCreditCheckInviteDirector />
      </DialogPage>
    </>
  );
};
